/* Vellaskim: carrito lateral. Abre el panel al añadir, actualiza cantidades sin recargar. */
(function () {
  if (window.__vkCart) return;
  window.__vkCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nf = window.fetch.bind(window);
  var last = null;

  function D() { return document.getElementById('vk-drawer'); }
  function sid() {
    var d = D(); if (!d) return null;
    var w = d.closest('[id^="shopify-section-"]');
    return w ? w.id.replace('shopify-section-', '') : null;
  }
  function body() { var d = D(); return d && d.querySelector('[data-vk-body]'); }
  function openOnAdd() { var d = D(); return !!d && d.getAttribute('data-open-on-add') !== 'false'; }
  function mark(on) { var b = body(); if (b) b.classList.toggle('vkc-busy', !!on); }
  function setCount() {
    var b = body(); if (!b) return;
    var c = parseInt(b.getAttribute('data-count') || '0', 10);
    document.querySelectorAll('[data-vk-count]').forEach(function (e) { e.textContent = c; e.hidden = c < 1; });
  }
  function open() {
    var d = D(); if (!d) return;
    if (!d.hidden && d.classList.contains('is-open')) return;
    last = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var p = d.querySelector('.vk-dr__panel'); if (p) p.focus(); }, 60);
  }
  function close() {
    var d = D(); if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { d.hidden = true; }, 280);
    if (last && last.focus) last.focus();
  }
  function refresh() {
    var id = sid(); if (!id) return Promise.resolve();
    return nf(root + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var t = document.createElement('div');
        t.innerHTML = j[id] || '';
        var nb = t.querySelector('[data-vk-body]');
        var ob = body();
        if (nb && ob) {
          var of = ob.querySelector('.vkc-fill'), w0 = of ? of.style.width : null;
          ob.replaceWith(nb);
          var nfl = nb.querySelector('.vkc-fill');
          if (nfl && w0 && w0 !== nfl.style.width) {
            var w1 = nfl.style.width;
            nfl.style.transition = 'none'; nfl.style.width = w0; void nfl.offsetWidth; nfl.style.transition = '';
            requestAnimationFrame(function () { nfl.style.width = w1; });
          }
        }
        setCount();
      })
      .catch(function () {});
  }
  function busy(f, on) {
    f.querySelectorAll('[type="submit"]').forEach(function (b) { b.disabled = on; b.setAttribute('aria-busy', on ? 'true' : 'false'); });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || e.defaultPrevented) return;
    if (f.closest('[data-vk-native]')) return;
    var a = f.getAttribute('action') || '';
    var inDrawer = !!f.closest('#vk-drawer');
    if (/\/cart\/add/.test(a)) {
      if (!D() || (!openOnAdd() && !inDrawer)) return;
      e.preventDefault();
      busy(f, true);
      open(); mark(true); /* el panel se abre al instante */
      nf(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) { alert(x.j.description || x.j.message || 'No se pudo agregar al carrito.'); return; }
          return refresh();
        })
        .catch(function () { f.submit(); })
        .finally(function () { busy(f, false); mark(false); });
    } else if (inDrawer && /\/cart\/change/.test(a)) {
      e.preventDefault();
      busy(f, true);
      nf(root + 'cart/change.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
        .then(refresh)
        .catch(function () { f.submit(); })
        .finally(function () { busy(f, false); });
    }
  });

  /* Apps (Kaching, etc.) que añaden al carrito por su cuenta: abrir el panel al instante y refrescar al terminar. */
  window.fetch = function (input, init) {
    var p = nf(input, init);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(u) && openOnAdd()) {
        open(); mark(true);
        p.then(function (r) { return r.ok ? refresh() : null; })
          .catch(function () {})
          .then(function () { mark(false); });
      }
    } catch (err) {}
    return p;
  };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('[data-vk-close]')) { e.preventDefault(); close(); return; }
    var l = t.closest('[data-vk-cart-link]');
    if (l && D() && !document.querySelector('[data-vk-native]')) { e.preventDefault(); open(); refresh(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    var d = D();
    if (e.key === 'Tab' && d && !d.hidden) {
      var f = d.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === sid()) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === sid()) close(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setCount); else setCount();
})();
